/** When set, partner login/signup links open the new partner panel instead of in-app routes. */
function normalizeBase(url: string): string {
  return url.replace(/\/+$/, '');
}

export function partnerLoginUrl(): string {
  const base = process.env.REACT_APP_PARTNER_PANEL_BASE_URL?.trim();
  if (base) {
    const path = process.env.REACT_APP_PARTNER_PANEL_LOGIN_PATH?.trim() || '/login';
    const p = path.startsWith('/') ? path : `/${path}`;
    return `${normalizeBase(base)}${p}`;
  }
  return '/partner-login';
}

export function partnerSignupUrl(): string {
  const base = process.env.REACT_APP_PARTNER_PANEL_BASE_URL?.trim();
  if (base) {
    const path = process.env.REACT_APP_PARTNER_PANEL_SIGNUP_PATH?.trim() || '/signup';
    const p = path.startsWith('/') ? path : `/${path}`;
    return `${normalizeBase(base)}${p}`;
  }
  return '/partner-registration';
}

/** Resolve footer or data paths that might point at partner flows. */
export function resolvePartnerNavTo(to: string): string {
  if (to === '/partner-login') return partnerLoginUrl();
  if (to === '/partner-registration') return partnerSignupUrl();
  return to;
}

export function isExternalHttpUrl(url: string): boolean {
  return /^https?:\/\//i.test(url);
}
